import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { OrdersPermissions } from './order-management.orders.permissions';

export class OrderPaymentsPermissions {
  static GroupName = `${OrdersPermissions.GroupName}.Payments`;

  static getPermissions = getGroupPermissionFactory(OrdersPermissions.GroupName);

  static Permissions = {
    ReadLatest: OrderPaymentsPermissions.getPermissions("ReadLatest"),
    ReadAll: OrderPaymentsPermissions.getPermissions(PermissionEnum.READ_ALL)
  };
}
